import React from 'react';
import AutoSizeTitle from '../../components/autoSizeTitle/AutoSizeTitle';
import IndividualInformHeader from '../../components/individualInformHeader/individualInformHeader';
import './pageFarewellSelfcare.css';

const PageFarewellSelfcare = ({ selectedEvaluation, individualResult, orgLogo, pageNumber }) => {
    const backgroundStyle = {
        backgroundImage: `url('/informs/pagina.png')`,
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'left top',
        backgroundSize: '100% auto',
    };

    return (
        <div className="pdf-page internal-page">
            <div className="internal-page-content" style={backgroundStyle}>
                <AutoSizeTitle text={selectedEvaluation?.evl_title} />

                <div className="internal-page-info internal-page-info-individual">
                    <IndividualInformHeader individualResult={individualResult} orgLogo={orgLogo} />

                    <div className="selfcare-farewell-text">
                        <p>Este informe no es un punto final; es un punto de partida.</p>

                        <p>
                            Cada resultado que aquí ves refleja cómo te encuentras hoy, no quién eres. Las condiciones físicas,
                            emocionales y de atención cambian, y con ellas también cambia el nivel de riesgo. Por eso, este informe
                            no busca señalar errores ni juzgar comportamientos, sino ayudarte a tomar mayor conciencia para cuidarte
                            mejor.
                        </p>

                        <p>
                            La seguridad comienza por las personas. Cuando reconoces tus límites, pides apoyo a tiempo y fortaleces
                            pequeños hábitos de autocuidado, reduces el riesgo no solo para ti, sino también para quienes trabajan
                            contigo y para quienes te esperan en casa.
                        </p>

                        <p>
                            Cada acción cuenta. Un descanso oportuno, una conversación a tiempo o una pausa consciente pueden
                            marcar la diferencia. Cuidarte es una decisión diaria, y hacerlo es una muestra de responsabilidad y
                            respeto por la vida.
                        </p>

                        <p>
                            Gracias por tu compromiso, por tu trabajo y por ser parte activa de una cultura donde el bienestar y la
                            seguridad son lo primero.
                        </p>

                        <p className="selfcare-farewell-strong">Tu cuidado importa. Tu seguridad importa.</p>
                    </div>
                </div>

                <div className="internal-page-number">{pageNumber}</div>
            </div>
        </div>
    );
};

export default PageFarewellSelfcare;
